import React from 'react';

import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  IconButton,
  DialogTitle as MuiDialogTitle,
  Theme,
  Typography,
} from '@mui/material';
import { WithStyles, createStyles, withStyles } from '@mui/styles';
import OverrideTheme from 'themes/custom-theme-helper';

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  withCloseBtn?: boolean;
  preventClose?: boolean;
  onClose: (event?: unknown, reason?: unknown) => void;
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(3),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
    closeIcon: {
      color: OverrideTheme.colors.primary,
      marginRight: 10,
    },
    successIcon: {
      paddingRight: 8,
      background: 'violet',
    },
  });

const DialogTitle = withStyles(styles)(({
  children,
  classes,
  onClose,
  withCloseBtn,
  ...props
}: DialogTitleProps) => {
  return (
    <MuiDialogTitle className={classes.root} {...props}>
      <Typography variant="h3">{children}</Typography>
      {withCloseBtn ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          color="primary"
          onClick={onClose}
        >
          <FontAwesomeIcon
            icon={faXmark}
            size="sm"
            className={classes.closeIcon}
          />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export default DialogTitle;
